import { defaultDateString } from "src/components/common/common";
import { ProductDowntimeDto } from "src/dtos/productDowntime/ProductDowntimeDto";
import { defaultProductResultDto, ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface KSK2030_R01Dto extends ProductResultDto {

	workDt: string | undefined;
	fromTime: string | undefined;
	toTime: string | undefined;
	workProcess: string;
	resultQty: number;
	closeTag: string;

	itemCost: number;
	lossPercent: number;

	downtimeSet: string;

	downtimeStartTime: string | undefined;
	downtimeStartDt: string | undefined;
	downtimeStartHour: number;
	downtimeStartMinute: number;

	downtimeEndTime: string | undefined;
	downtimeEndDt: string | undefined;
	downtimeEndHour: number;
	downtimeEndMinute: number;

	downtimeCase: string;
    
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultKSK2030_R01Dto: KSK2030_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',
	
	inserted: false,
	isModified: false,

	workDt: formatDate(new Date()),
	fromTime: toLocalDateTime(new Date(defaultDateString)),
	toTime: toLocalDateTime(new Date(defaultDateString)),
	workProcess: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",

	itemCost: 0,
	lossPercent: 0,

	downtimeSet: '',
	
	downtimeStartTime: toLocalDateTime(new Date()),
	downtimeStartDt: formatDate(new Date()),
	downtimeStartHour: 0,
	downtimeStartMinute: 0,

	downtimeEndTime: toLocalDateTime(new Date()),
	downtimeEndDt: formatDate(new Date()),
	downtimeEndHour: 0,
	downtimeEndMinute: 0,
	
	downtimeCase: '',
};

export interface KSK2030_R01DetailDto extends ProductDowntimeDto {
}

export const defaultKSK2030_R01DetailDto: KSK2030_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	productResultNo: '',
	downtimeNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productEmp: '',
	productEmpNm: '',
	fromTime: toLocalDateTime(new Date(new Date().setHours(9))),
	toTime: toLocalDateTime(new Date(new Date().setHours(9))),
	downtimeCase: '',
	remark: '',

	inserted: false,
	isModified: false

};
